import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {WritableAssayValidationStatus} from 'results/validation/ValidationConstants';
import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  className?: string;
  status: WritableAssayValidationStatus;
}

export default function ValidationIcon({className, status}: Props): JSX.Element {
  const isValid = status === WritableAssayValidationStatus.VALID;
  return (
    <BenchlingIcon
      icon={isValid ? 'check' : 'close'}
      className={classNames(className, css(isValid ? styles.checkIcon : styles.closeIcon))}
      dataTestAttrs={
        isValid
          ? {component: 'ValidationIcon', element: 'valid'}
          : {component: 'ValidationIcon', element: 'invalid'}
      }
    />
  );
}

const styles = StyleSheet.create({
  checkIcon: {
    color: Colors.BLUE_LIGHT,
  },
  closeIcon: {
    color: Colors.ORANGE,
  },
});
